import React, { useState, useEffect } from "react";
import { useAtom } from "jotai";




import { activeChildDetail } from "../../atomstore/store";
import { useRequestProcessor } from "../../requestProcessor";
import SpinnerLoading from "./SpinnerLoading";
import { getSurveyParams } from "../../queryfunctions/queryfunctions";


const RIGHT_QUESTION = "What can we do for a better recommendation from you?";
const WRONG_QUESTION = "Please tell us what you like most about footprints.";

const SurveyForm = ({ onRatingPressed, getTags, getComment, selectedChild }) => {
    const { useQueryWrapper } = useRequestProcessor();


    const [rating, setRating] = useState(0);
    const [selectedItem, setSelectedItem] = useState(null);
    // selectedCheckboxes stores selections grouped by category key (same shape as old)
    const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
    const [comment, setComment] = useState("");
    const [loading, setLoading] = useState(false);

    const { data: questions } = useQueryWrapper(
        ["getSurveyParams"],
        () => getSurveyParams(selectedChild)
    );

    const handleRatingChange = (val) => {
        const ratingVal = Number(val);

        // 1. update local rating
        setRating(ratingVal);

        // 2. find matching category for this rating
        const newSelectedItem = questions?.find(
            (item) =>
                ratingVal <= parseInt(item.cat_max, 10) &&
                ratingVal >= parseInt(item.cat_min, 10)
        ) || null;

        // 3. check if category changed
        const categoryChanged = selectedItem?.cat_key !== newSelectedItem?.cat_key;

        // 4. update selectedItem FIRST so UI re-renders with new tags
        setSelectedItem(newSelectedItem);

        // 5. clear checkboxes + notify parent
        if (categoryChanged) {
            setSelectedCheckboxes({});
            if (typeof getTags === "function") getTags([]);
        }

        // 6. notify parent rating change
        if (typeof onRatingPressed === "function") {
            onRatingPressed(ratingVal);
        }
    };


    // toggle a single checkbox item for the current category
    const toggleTag = (item, checked) => {
        if (!selectedItem) return;

        const key = selectedItem.cat_key;

        // WRAP LIKE OLD SYSTEM
        const wrapped = {
            value: item,          // entire item object
            label: item.value,    // show text
        };

        const current = selectedCheckboxes[key] || [];

        let updated;
        if (checked) {
            if (!current.some((x) => x.value.value === item.value)) {
                updated = [...current, wrapped];
            } else {
                updated = current;
            }
        } else {
            updated = current.filter((x) => x.value.value !== item.value);
        }

        const newState = { ...selectedCheckboxes, [key]: updated };
        setSelectedCheckboxes(newState);

        if (getTags) getTags(updated);
    };

    // comment change handler
    const handleCommentChange = (e) => {
        const txt = e.target.value;
        setComment(txt);
        if (typeof getComment === "function") getComment(txt);
    };

    // show spinner while loading questions
    if (!questions) return <div />;

    return (
        <div className="w-full">
            {loading && <SpinnerLoading />}

            <div className="space-y-6">
                {/* Rating */}
                <div>
                    <p className="text-sm font-semibold mb-2">
                        How likely would you recommend Footprints to your friends and colleagues?
                    </p>

                    <input
                        type="range"
                        min="1"
                        max="10"
                        value={rating}
                        onChange={(e) => handleRatingChange(e.target.value)}
                        className="w-full outline-none"
                    />
                    <p className="text-center text-sm mt-1">Rating: {rating}</p>
                </div>

                {/* Tags for selected category */}
                {selectedItem && (
                    <div className="bg-white rounded-xl p-4 shadow-sm">
                        <h3 className="text-md font-semibold mb-3">{selectedItem.cat_slug}</h3>

                        <div className="space-y-2">
                            {selectedItem.data.map((item, idx) => {
                                const isChecked =
                                    (selectedCheckboxes[selectedItem.cat_key] || []).some(
                                        (x) => x.value.value === item.value

                                    );

                                return (
                                    <label
                                        key={idx}
                                        className="flex items-center space-x-3 bg-gray-50 px-3 py-2 rounded-lg border"
                                    >
                                        <input
                                            type="checkbox"
                                            checked={isChecked}
                                            className="outline-none"
                                            onChange={(e) => toggleTag(item, e.target.checked)}
                                        />
                                        <span className="text-sm">{item.value}</span>
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* Comment */}
                {rating !== 0 && (
                    <div>
                        <label className="text-sm font-medium mb-1 block">
                            {rating < 9 ? RIGHT_QUESTION : WRONG_QUESTION}
                        </label>
                        <textarea
                            className="w-full border border-gray-300 p-3 rounded-xl h-24 focus:ring-2 focus:ring-cyan-500 outline-none focus:border-transparent"
                            placeholder="Type your feedback here..."
                            value={comment}
                            onChange={handleCommentChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default SurveyForm;
